export enum MarketRequestType {
  Primary = 'Primary',
  Excess = 'Excess',
}
